const breadCrumb = "Lotação de Servidores - Regime Complementar";

const routes = [
  {
    path: "/relatorio-de-cadastro-de-disponibilidade",
    name: "relatorio-de-cadastro-de-disponibilidade",
    meta: {
      requireAuth: false,
      // allowedPermissions: ["carga_horaria_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RegimeComplementar/RelatorioDeCadastroDeDisponibilidade/RelatorioDeCadastroDeDisponibilidadeHome.vue"
      ),
  },
];

export default routes;
